import { Pause, Play, Loader2, X } from "lucide-react";
import { useAudioPlayer } from "@/contexts/AudioPlayerContext";
import { getCurrentChapter } from "@scroll/shared-utils";

interface MiniPlayerProps {
  onExpand: () => void;
}

export default function MiniPlayer({ onExpand }: MiniPlayerProps) {
  const { currentEpisode, isPlaying, isBuffering, positionMs, durationMs, pause, resume, stop } =
    useAudioPlayer();

  if (!currentEpisode) return null;

  const progress = durationMs > 0 ? (positionMs / durationMs) * 100 : 0;
  const currentChapter = getCurrentChapter(
    currentEpisode.chapterMarkers ?? [],
    positionMs,
  );

  return (
    <div className="mini-player" onClick={onExpand}>
      {/* Progress bar */}
      <div className="mini-player-progress">
        <div
          className="mini-player-progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      <div className="mini-player-content">
        {/* Artwork */}
        {currentEpisode.artworkUrl ? (
          <img
            src={currentEpisode.artworkUrl}
            alt=""
            className="mini-player-artwork"
          />
        ) : (
          <div className="mini-player-artwork mini-player-artwork-placeholder" />
        )}

        {/* Text */}
        <div className="mini-player-text">
          <span className="mini-player-title">{currentEpisode.title}</span>
          {currentChapter ? (
            <span className="mini-player-chapter">Now: {currentChapter.title}</span>
          ) : currentEpisode.podcastTitle ? (
            <span className="mini-player-podcast">{currentEpisode.podcastTitle}</span>
          ) : null}
        </div>

        {/* Play/Pause */}
        <button
          className="mini-player-btn"
          onClick={(e) => {
            e.stopPropagation();
            isPlaying ? pause() : resume();
          }}
          aria-label={isPlaying ? "Pause" : "Play"}
        >
          {isBuffering ? (
            <Loader2 size={20} className="animate-spin" />
          ) : isPlaying ? (
            <Pause size={20} fill="currentColor" />
          ) : (
            <Play size={20} fill="currentColor" />
          )}
        </button>
        <button
          className="mini-player-btn mini-player-close-btn"
          onClick={(e) => {
            e.stopPropagation();
            stop();
          }}
          aria-label="Close player"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
